module.exports = __webpack_public_path__ + "static/media/hey.284abd18.jpg";